import { Link } from "react-router-dom";
import LandingNav from "./LandingNav";
import LandingFooter from "./LandingFooter";

/**
 * Yellow "à compléter" placeholder used across all legal pages while the
 * editor's incorporation information is finalized. Visible enough to be
 * spotted at a glance in production before the docs are legally usable.
 */
export function P({ label = "À COMPLÉTER" }) {
  return (
    <mark
      className="bg-[#FFF3D6] text-[#B76A00] px-1.5 py-0.5 rounded font-semibold text-[13px] border border-[#F0DDA8] no-underline"
      title="Champ à compléter par l'éditeur"
    >
      [{label}]
    </mark>
  );
}

export const Section = ({ title, children, id }) => (
  <section id={id} className="mb-10 scroll-mt-24">
    <h2 className="text-2xl font-bold tracking-tight text-[#1E3A5F] mb-4">{title}</h2>
    <div className="text-[#1E3A5F] leading-relaxed space-y-3">{children}</div>
  </section>
);

export const LegalFooterLinks = ({ current }) => {
  const items = [
    { to: "/mentions-legales", label: "Mentions légales" },
    { to: "/cgu", label: "CGU" },
    { to: "/cgv", label: "CGV" },
    { to: "/confidentialite", label: "Confidentialité" },
  ];
  return (
    <nav className="mt-12 pt-6 border-t border-[#E1E9F0] flex flex-wrap items-center gap-x-5 gap-y-2 text-[13px]">
      {items.map((i) => (
        i.to === current ? (
          <span key={i.to} className="text-[#5F758F] font-semibold">{i.label}</span>
        ) : (
          <Link key={i.to} to={i.to} className="text-[#3A8FA5] hover:text-[#164E5F] font-semibold">{i.label}</Link>
        )
      ))}
    </nav>
  );
};

export default function LegalLayout({ eyebrow, icon: Icon, title, intro, children, updatedAt = "10 mars 2026", path }) {
  return (
    <div className="min-h-screen bg-[#F4F7FB] text-[#1E3A5F]">
      <LandingNav />

      <main className="max-w-3xl mx-auto px-6 pt-32 pb-16">
        <p className="text-xs tracking-[0.3em] uppercase text-[#3A8FA5] mb-6 flex items-center gap-2">
          {Icon && <Icon size={16} weight="duotone" />} {eyebrow}
        </p>
        <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 leading-tight text-[#1E3A5F]">{title}</h1>
        {intro && <p className="text-[#5F758F] text-lg leading-relaxed mb-12">{intro}</p>}
        {children}
        <p className="text-xs text-[#5F758F] mt-16 pt-6 border-t border-[#E1E9F0]">
          Dernière mise à jour : {updatedAt}
        </p>
        <LegalFooterLinks current={path} />
      </main>

      <LandingFooter />
    </div>
  );
}
